import React from "react";

const Banking_Past_Listing = () => {
  return <div>Banking_Past_Listing</div>;
};

export default Banking_Past_Listing;
